const problems = [
  {
    icon: 'ri-eye-line',
    title: 'Görünür Problem',
    text: 'Lisans değişiklikleri maliyetleri altyapı TCO\'sunun %15-25\'inden %30-40\'ına çıkardı. Organizasyonlar bu fiyat artışına hiper yönetici değiştirme stratejileriyle tepki gösterdi.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Gizli Problem',
    text: 'Ayrı depolama, hesaplama ve ağ ürünlerindeki koordinasyon yükü, altyapı ekibinin zamanının %40-60\'ını tüketiyor. Bu operasyonel maliyet Broadcom\'dan önce de vardı ve hiper yönetici değişiminden sonra da devam ediyor.',
  },
  {
    icon: 'ri-question-line',
    title: 'Kimsenin Sormadığı Soru',
    text: 'Lisans sorununu mu yoksa altyapı sorununu mu çözüyorsunuz? Satın alma birimi lisans maliyetlerini görür. Operasyon ekibi önümüzdeki beş yıl boyunca koordinasyon yükünü öder.',
  },
];

export default function OBProblem() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-4">
          Çoğu Organizasyonun Planladığı Değişiklik
        </h2>
        <p className="text-center text-gray-500 text-sm mb-12 max-w-xl mx-auto">
          Sorunun tamamını çözmeden adım atmak, daha büyük bir sorunu beraberinde getirir.
        </p>
        <div className="grid md:grid-cols-3 gap-6">
          {problems.map((p) => (
            <div key={p.title} className="rounded-lg border border-gray-100 bg-[#f8fafc] p-7">
              <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mb-4">
                <i className={`${p.icon} text-xl`}></i>
              </span>
              <h3 className="font-bold text-[#1e293b] mb-3 text-base">{p.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
